export function getEnvironmentAccountId() {
  const accountId = process.env.NEXT_PUBLIC_ACCOUNT_ID?.trim();

  return process.env.NODE_ENV === "development" && accountId ? accountId : null;
}

export function getEffectiveAuthenticatedAccountId(accountId?: string | null) {
  return getEnvironmentAccountId() ?? accountId ?? null;
}
